module.exports = __webpack_public_path__ + "static/media/ding.8c493f6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/Workbench2/UI.MenuNew/Icon/ding.svg
// module id = 6771
// module chunks = 0